// Network status + external app handoff. Capacitor: swap for @capacitor/network and @capacitor/app-launcher.
export const network = {
  isOnline: () => (typeof navigator === "undefined" ? true : navigator.onLine),
  subscribe(cb: (online: boolean) => void): () => void {
    const on = () => cb(true);
    const off = () => cb(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  },
};

export const external = {
  navigateTo(lat: number, lng: number) {
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`, "_blank", "noopener");
  },
  call(number: string) {
    window.location.href = `tel:${number.replace(/\s/g, "")}`;
  },
  open(url: string) {
    window.location.assign(url);
  },
};
